import { combineReducers } from "@reduxjs/toolkit";
import authReducer, { AuthReducerState } from "./auth-reducer";
import serviceReducer, {ServiceReducerState } from "./service-reducer";
import errorReducer, { ErrorReducerState } from "./error-reducer";
import dialogReducer from "./dialog-box";
import { uiReducer } from "./ui-reducer";

const appReducer = combineReducers({
  auth: authReducer,
  error: errorReducer,
  service: serviceReducer,
  dialog: dialogReducer,
  ui: uiReducer,
});

interface DialogState {
  openTime: number | null;
  duration: number;
}

export interface RootState {
  auth: AuthReducerState;
  error: ErrorReducerState;
  service: ServiceReducerState;
  dialog: DialogState;
}

const rootReducer = (
  state: RootState | undefined,
  action: { type: string }
) => {
  if (action.type === "GLOBAL_RESET") {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
